// $( document ).ready(function() {
//     addCloseMenu();
// });


// function addCloseMenu(){
//   if(document.getElementById("NavDrawer")){
//     var closebtn = `
// 		<button type="button" class="close icon-fallback-text site-nav__link site-nav__link--burger js-drawer-open-button-left" aria-controls="NavDrawer" aria-expanded="true">
//           <span class="burger-icon burger-icon--top"></span>
//           <span class="burger-icon burger-icon--mid"></span>
//           <span class="burger-icon burger-icon--bottom"></span>
//           <span class="fallback-text">Site navigation</span>
//         </button>
// 	`;
// 	$( "#NavDrawer" ).append(closebtn)
//   }
// }

$('#AddToCart--product-template').click(function(){
  var qttys = 0
  
  var detectCartChange = setInterval(function() {  
    if (cartItems) {
      	$('.cart__checkout').attr('disabled', 'disabled')
		
        var items = cartItems.items	
      	
        $(items).each(function(){
        	if (this.product_type == 'Weekly Meal') {
          		qttys += this.quantity
        	}
        })
        
        console.log(qttys)
        
        if (qttys >= 10) {
        	$('.cart__checkout').removeAttr('disabled')
        }
      
        $('.ajaxcart__qty--minus').click(function() {
          
          setTimeout(function () {
            $.getJSON(ShopifyAPI.cartRoutes.cartUrl + '.js', function(cart) {
              var qttys = 0

              $(cart.items).each(function(){
                if (this.product_type == 'Weekly Meal') {
                  qttys += this.quantity
                }
              })

              console.log(qttys)

              if (qttys >= 10) {
                $('.cart__checkout').removeAttr('disabled')
              } else {
                $('.cart__checkout').attr('disabled', 'disabled')
              }
            });
          }, 2000);
          
        })
        
      	clearInterval(detectCartChange)
    }
  }, 100);
})

$(document).ready(function() {                   
  if (window.location.href.indexOf("/products/create-necklace") > -1) {
    $('#AddToCart--product-template').hide(); 
    
    $('.product-single__add-to-cart').before(`
      <div>
        <label for="letters">Letters for collar:</label>
        <input type="text" id="letters" maxlength="2" style="border:solid 1px #000;margin-top:10px;margin-bottom:15px;">
      </div>
      <button type="button" class="btn" id="custom-add-to-cart">Add To Cart</button> 
    `) 

    $('input[name=option1]').change(function() { 
      $("#letters").val('')
      $("#letters").prop('maxLength', $(this).val())
    }) 

    $('#custom-add-to-cart').click(function() {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
          'attributes': {
            'Letters for collar': $('#letters').val(),
          }  
        },
        dataType: 'json',
        success: function() { 
          $.getJSON('/cart.js', function(cart) {
            $('#AddToCart--product-template').click()  
          })
        } 
      }) 
    })
  }   
});


/*

**** Important ****

Attention:

 Using JavaScript vanilla "window.onload" event handler instead of
 "jQuery's $(document).ready()" method.

Cause:

 The latter method causes the Instafeed to load duplicated content


*/
window.onload = function(){
  
	if(window.location.pathname === '/') {
      
      var feed = new Instafeed({
        
        get: 'user',
        userId: 'bysandrafrometa',
        accessToken: 'IGQVJXcXVaQU05TFhRaU5XTk5hUy02bEZAuWlJuLUVTNWxIQzRpWWxEQlNBOUlhdi1GWnNDdzA2a0ZAoeFlfZAHdxRkgtY1loSlAxVGJMN3RIcE1jTlF3UEJMT1A5bEpmWGtGQmNJR3ZADU1ktb2VrWXlBSQZDZD',
        template: '<div class="equal-height"><a href="https://www.instagram.com/bysandrafrometa" target="_blank"><img style="min-height:50px;background-color:#fff;width:100%" title="{{caption}}" src="{{image}}" /></a></div>',
        limit: 6
      });

      feed.run();
    }                  
};
